import type { RelatedSearch } from "./searchModel";
import { SectionHeading } from "./SectionHeading";

interface RelatedSearchesProps {
  searches: RelatedSearch[];
  /** Runs the tile's query as a brand-new search. */
  onSearchClick: (query: string) => void;
}

/**
 * Visual query tiles below the results. These are searches, not refinements —
 * clicking one commits a new query rather than narrowing the current one.
 */
export function RelatedSearches({
  searches,
  onSearchClick,
}: RelatedSearchesProps) {
  return (
    <div className="pt-12 pb-8 text-center">
      <div className="mb-4">
        <SectionHeading>Related searches</SectionHeading>
      </div>
      <div className="overflow-x-auto">
        <div className="flex min-w-max justify-start gap-4 sm:min-w-0 sm:justify-center">
          {searches.map((search) => (
            <RelatedSearchTile
              key={search.id}
              search={search}
              onClick={() => onSearchClick(search.query)}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

interface RelatedSearchTileProps {
  search: RelatedSearch;
  onClick: () => void;
}

function RelatedSearchTile({ search, onClick }: RelatedSearchTileProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="group flex cursor-pointer flex-col items-center gap-3"
    >
      <div className="relative h-[128px] w-[128px] overflow-hidden rounded-[4px] bg-[#f5f5f5]">
        <img
          src={search.imageUrl}
          alt={search.label}
          className="h-full w-full object-cover transition-transform group-hover:scale-105"
          referrerPolicy="no-referrer"
        />
        <div className="pointer-events-none absolute inset-0 bg-(--slate-color-grey-1000)/[0.03]" />
      </div>
      <span className="type-fs-paragraph-medium text-fs-text-primary">
        {search.label}
      </span>
    </button>
  );
}
